import { createContext } from "react";
import { Menu } from "../helper/interface";

export interface MenuContextType {
  menus: Menu[];
  loading: boolean;
  hasAccess: (path: string) => boolean;
}

export const MenuContext = createContext<MenuContextType | undefined>(
  undefined
);
